module.exports = __webpack_public_path__ + "static/media/2.5f9b2626.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/eyes/2.png
// module id = 1226
// module chunks = 0